import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Warning as WarningIcon } from "@mui/icons-material";
import { ButtonBase, FormControl, FormHelperText, InputLabel, Tooltip, Typography, } from "@mui/material";
export const LabeledValueWithButton = ({ error, children, label, labelIcon: LabelIcon, labelProps, style, iconFontSize = "medium", onClick, size = "medium", warning, disabled, ...otherProps }) => {
    return (_jsxs(FormControl, { disabled: disabled, error: Boolean(error), children: [_jsxs(ButtonBase, { focusRipple: true, onClick: onClick, disabled: disabled, sx: theme => ({
                    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
                }), children: [size !== "extra-small" && (_jsxs(InputLabel, { shrink: true, children: [label, LabelIcon && (_jsx(LabelIcon, { sx: {
                                    fontSize: "1.25em",
                                    verticalAlign: "text-bottom",
                                    marginLeft: 0.5,
                                } })), warning && (_jsx(Tooltip, { title: warning, sx: { pointerEvents: "auto" }, children: _jsx("span", { children: _jsx(WarningIcon, { color: "warning", sx: {
                                            fontSize: "1.25rem",
                                            verticalAlign: "text-bottom",
                                            marginLeft: 0.5,
                                        } }) }) }))] })), _jsx(Typography, { component: "div", variant: "body1", align: "left", sx: theme => ({
                            // copied over from input
                            padding: size === "extra-small" ? "4px 4px 3px 4px" : "21px 12px 4px",
                            maxWidth: "100%",
                            wordWrap: "break-word",
                            alignSelf: "stretch",
                            boxSizing: "content-box",
                            minHeight: "1.4375em",
                            lineHeight: "1.4375em",
                            minWidth: 0,
                            width: size === "extra-small" ? "calc(100% - 8px)" : "calc(100% - 24px)",
                            transition: "background-color 0.1s ease-out",
                            backgroundColor: !disabled
                                ? `rgb(232, 240, 245)`
                                : `rgba(0, 0, 0, 0.12)`,
                            ...(!disabled
                                ? {
                                    ["&:hover, &:active"]: {
                                        backgroundColor: `rgb(242, 246, 250)`,
                                    },
                                }
                                : { color: `rgba(0, 0, 0, 0.38)` }),
                            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
                        }), ...otherProps, children: children })] }), Boolean(error) && _jsx(FormHelperText, { children: error })] }));
};
//# sourceMappingURL=LabeledValueWithButton.js.map